.navigation {
  display: flex;
  justify-content: flex-end;

  & > * {
    margin-left: 1em;
  }
}
